<template>
	<td class="py-4 text-left first:pl-4 last:pr-4 px:2" v-on="$listeners">
		<slot>
			<div class="text-md leading-5 text-gray-900" :title="value">{{ value }}</div>
			<div class="text-md leading-5 text-gray-500" :title="subValue" v-if="subValue">{{ subValue }}</div>
		</slot>
	</td>
</template>

<script>
export default {
	name: 'BaseColumn',
	props: {
		value: {},
		subValue: {},
	},
};
</script>
